







































import {Component, Prop, Vue} from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'
import ResetPasswordRequest from '../../model/request/ResetPasswordRequest'

@Component
export default class ResetPasswordView extends Vue {
  @Action('auth/resetPassword') resetPassword!: Function
  request = new ResetPasswordRequest()
}
